import { setMeta } from '@/helpers/metaHelpers.js'

export const seo = {
  actions: {
    updateRiddleSeo(context, { count, seo: seoData }) {
      setMeta({
        description: seoData.description,
        image: seoData.image,
        title: seoData.title.replace('[COUNT]', count),
      })
    },
  },
}
